export enum ServiceCaseMessageKey {
  LOCKED_MODIFICATION_REJECTED = 'case.lockedModificationRejected'
}
